// SETUP COLORS
export const APP_THEME = '#bcba79';
export const APP_BACKGROUND = '#d8d3d1';
export const APP_FONT = '#000000';

export const GREY = {
  0: '#FFFFFF',
  100: '#e9e4e1',
  200: '#141414',
  300: '#DFE3E8',
  400: '#252524',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
};

export const PRIMARY = {
  lighter: '#c0bd7c',
  light: '#c6c285',
  main: '#bbb779',// '#bbb779',
  dark: '#848042',// '#b7b575',
  darker: '#77733c',
  contrastText: '#000',
};

export const SECONDARY = {
  light: '#d8d3d1',
  main: '#141414',// '#6b7280',
  dark: '#252524',
};

export const INFO = {
  lighter: '#D0F2FF',
  light: '#74CAFF',
  main: '#1890FF',
  dark: '#0C53B7',
  darker: '#04297A',
  contrastText: '#fff',
};

export const SUCCESS = {
  lighter: '#E9FCD4',
  light: '#AAF27F',
  main: '#54D62C',
  dark: '#229A16',
  darker: '#08660D',
  contrastText: GREY[800],
};

export const WARNING = {
  lighter: '#FFF7CD',
  light: '#FFE16A',
  main: '#FFC107',
  dark: '#B78103',
  darker: '#7A4F01',
  contrastText: GREY[800],
};

export const ERROR = {
  lighter: '#FFE7D9',
  light: '#FFA48D',
  main: '#FF4842',
  dark: '#B72136',
  darker: '#7A0C2E',
  contrastText: '#fff',
};
